import * as React from 'react';
import * as autoBind from 'react-autobind';
import ContentTypeParser from '../../utils/ContentTypeParser/ContentTypeParser';
import SimpleImage from '../SimpleImage/SimpleImage';

export default class MediaPreview extends React.Component<MediaPreviewProps, MediaPreviewState> {
   readonly state: MediaPreviewState = {isLoaded: false};

   constructor(props: MediaPreviewProps) {
      super(props);
      autoBind(this);
   }

   setVideoLoaded() {
      this.setState({isLoaded: true});
   }

   render() {
      const {mediaUrl, mediaContentType} = this.props;
      const videoClass = this.state.isLoaded ? 'video-container-visible' : 'video-container-hidden';

      return (
         <div className="media-container">
            {ContentTypeParser.getContentTypeIsVideo(mediaContentType) ?
               <video className={videoClass} controls onLoadedMetadata={this.setVideoLoaded}>
                  <source src={mediaUrl} type="video/mp4"/>
               </video> :
               <SimpleImage mediaUrl={mediaUrl}/>
            }
         </div>
      );
   }
}

export interface MediaPreviewProps {
   mediaUrl: string;
   mediaContentType: string;
}

interface MediaPreviewState {
   isLoaded: boolean;
}